export default "__VITE_ASSET__rESxx9Im__"